import { _ as a } from "./index918.mjs";
import { _ as t } from "./index837.mjs";
var r = a, o = t, e = r(o, "DataView"), v = e;
export {
  v as _
};
